export type Sandbox = {
  /** Human-readable sandbox name shown in the widget. */
  name: string;
  /** Signadot routing key identifying the sandbox (from the `sd-routing-key` cookie). */
  routingKey: string;
  /** Whether the sandbox is up and connectable. Absent is treated as ready. */
  ready?: boolean;
  /** `true` for a Devbox, `false`/absent for a Fork */
  hasLocalWorkloads?: boolean;
  /** URL of the pull request that created a Fork. Not set for a Devbox. */
  prUrl?: string;
};

export const SANDBOXES_ENDPOINT =
  "https://platform-admin-test.junipersquare.us/remocal/api/sandboxes";

export const DISCONNECT_PATH = "/remocal/disconnect";

/** Max recent sandboxes retained in storage and shown in the main panel. */
export const MAX_RECENT_SANDBOXES = 5;
